import { render, staticRenderFns } from "./Table.vue?vue&type=template&id=5a62f68c&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Table.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/icons/Table.vue
// module id = 1752
// module chunks = 1